import axios from "axios";
import { Loading, Notify } from "notiflix";
import { APIURL } from "./config";
import { ACTIVITY_LIST, CATEGORY_LIST, COMP_AGE, COMP_LIST, EVENT_DETAILS, EVENT_PROPS, EVENT_STUDENT, EXP_AGE, EXP_LIST, ONGOING_EVENTS, PAST_EVENTS, PENDING_SUBMISSION_KIDS, QUIZ_AGE, QUIZ_LIST, SUBMISSION_LIST } from "./types";

export const getEvents = (data) => async dispatch => {
   const { isOnGoingProgram } = data;
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/events`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: isOnGoingProgram ? ONGOING_EVENTS : PAST_EVENTS,
            payload: res?.data?.body,
         });
      } else if (!res?.data?.status) {
         dispatch({
            type: isOnGoingProgram ? ONGOING_EVENTS : PAST_EVENTS,
            payload: {},
         });
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getEventByName = (params, cb) => async dispatch => {
   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/champions/event/code?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: EVENT_DETAILS,
            payload: res?.data?.data
         });
         if (cb) cb(res?.data?.data);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err.response);
   }
}

export const getCateoryList = (params, cb) => async dispatch => {
   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/competition/categories?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: CATEGORY_LIST,
            payload: res?.data?.data
         });
         if (cb) cb(res?.data?.data?.[0]?.category_id);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err.response);
   }
}

export const getActivityList = params => async dispatch => {

   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/competition/activities/age?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: ACTIVITY_LIST,
            payload: res?.data?.data
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err);
   }
}

export const getEventProps = params => async dispatch => {
   const config = {
      headers: { 'ContentType': 'application/json' },
      data: {}
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/champions/event/properties?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: EVENT_PROPS, payload: res?.data?.data });
      } else if (!res?.data?.status) {
         dispatch({ type: EVENT_PROPS, payload: {} });
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err.response);
   }
}

export const getGuestEvents = data => async dispatch => {
   const { event_type } = data;
   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/champions/event/open`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: event_type === 0 ? COMP_LIST : event_type === 1 ? EXP_LIST : QUIZ_LIST,
            payload: res?.data?.data
         });
      } else if (res?.data?.message) {
         dispatch({
            type: event_type === 0 ? COMP_LIST : event_type === 1 ? EXP_LIST : QUIZ_LIST,
            payload: []
         });
      } else {
         dispatch({
            type: event_type === 0 ? COMP_LIST : event_type === 1 ? EXP_LIST : QUIZ_LIST,
            payload: []
         });
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err);
   }
}

export const saveEventAge = (age, type) => async dispatch => {
   dispatch({
      type: type === 0 ? COMP_AGE : type === 1 ? EXP_AGE : QUIZ_AGE,
      payload: age
   });
}

export const kidsPendingSubmission = params => async dispatch => {
   const config = {
      headers: { 'ContentType': 'application/json' },
      data: {}
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/school-dashboard/student-submission?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: PENDING_SUBMISSION_KIDS, payload: res?.data?.body });
      } else if (!res?.data?.status) {
         dispatch({ type: PENDING_SUBMISSION_KIDS, payload: [] });
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err.response);
   }
}

export const getStudentByEvent = params => async dispatch => {
   const config = {
      headers: { 'ContentType': 'application/json' },
      data: {}
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/school-dashboard/student-submission?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: EVENT_STUDENT, payload: res?.data?.body });
      } else if (!res?.data?.status) {
         dispatch({ type: EVENT_STUDENT, payload: [] });
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err.response);
   }
}

export const getKidSubmission = params => async dispatch => {
   const { kidId } = params;
   delete params["kidId"];
   const config = {
      headers: { 'ContentType': 'application/json' },
      data: {}
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/competition/submission/kid/${kidId}?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: SUBMISSION_LIST, payload: res?.data?.data });
      } else if (!res?.data?.status) {
         dispatch({ type: SUBMISSION_LIST, payload: [] });
      } else {
         Notify.warning("something went wrong");
      }

   } catch (err) {
      Loading.remove();
      console.log("err >>", err.response);
   }
}

export const submitActivity = (data, params, cb) => async dispatch => {

   const config = {
      headers: {
         'Content-Type': 'multipart/form-data',
      }
   };
   const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/competition?${queryString}`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ? res?.data?.message : "data imported successfully!"
         Notify.success(message);
         if (cb) cb();
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const removeSubmission = (data, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/competition/submission`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ? res?.data?.message : "Submission deleted!"
         Notify.success(message);
         if (cb) cb();
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const reviewSubmission = (data, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/assesment/review`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ? res?.data?.message : "Submission marked for review!"
         Notify.success(message);
         if (cb) cb();
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const resetEventDetails = () => async dispatch => {
   dispatch({ type: EVENT_DETAILS, payload: {} })
}